import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';
import { action } from 'satcheljs/lib/legacy';

/**
 * Toggle the expansion of group tree and update both local and server user config
 */
export default action('toggleGroupTreeExpansion')(function toggleGroupTreeExpansion() {
    const userOptions = getUserConfiguration().UserOptions;
    userOptions.IsGroupsTreeCollapsed = !userOptions.IsGroupsTreeCollapsed;

    updateUserConfiguration('OWA.UserOptions', [
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['IsGroupsTreeCollapsed'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'Boolean',
                Value: [String(userOptions.IsGroupsTreeCollapsed)],
            }),
        }),
    ]);
});
